import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { toast } from "sonner";

// Fonction d'enregistrement du Service Worker simplifiée
const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      console.log("[ServiceWorker] Tentative d'enregistrement...");
      const swUrl = import.meta.env.DEV ? "/sw.js" : "/sw.js?v=" + Date.now();
      const registration = await navigator.serviceWorker.register(swUrl, {
        scope: "/",
        type: "classic",
        updateViaCache: "none",
      });

      console.log(
        "[ServiceWorker] Enregistré avec succès, scope:",
        registration.scope
      );

      // Écouter les erreurs
      navigator.serviceWorker.addEventListener("error", (error) => {
        console.error("[ServiceWorker] Erreur:", error);
      });
    } catch (error) {
      console.error("[ServiceWorker] Erreur d'enregistrement:", error);
      toast.error("Erreur lors de l'installation des notifications push");
    }
  } else {
    console.log("[ServiceWorker] Non supporté par le navigateur");
  }
};

// Attendre que la page soit chargée
window.addEventListener("load", () => {
  console.log("[ServiceWorker] Page chargée, démarrage de l'enregistrement");
  registerServiceWorker();
});

// Rendu de l'application
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
